module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nfl/icons_passing_tds_orange-1ebbfe6de0ec21b9036beafe4c9807d8.svg";